export default __webpack_public_path__ + "static/media/phone_2.0f3fc668.svg";